<template>
    <div class="page-mask" :style="styles"></div>
</template>

<script>
    export default {
        name:  'PageMask',
        props: {
            displayNotAllowedCursor: {
                type:    Boolean,
                default: false,
            },
        },
        computed: {
            styles() {
                return {
                    cursor: this.displayNotAllowedCursor ? 'not-allowed' : 'default',
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .page-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0);
        z-index: 1001;
    }
</style>
